<template>
  <div>
    <div class="col-md-11 mx-auto feeds" style="height:100vh;overflow:scroll">
      <div class="d-flex col-md-12 mb-4 p-0">
        <h2>what's new</h2>
        <p class="my-auto ml-2"><b-badge variant="warning">Beta</b-badge></p>
      </div>
      <b-modal centered v-model="trial" hide-footer title="View Profile">
        <uaview :userAgentData="selectedAgent"></uaview>
      </b-modal>
      <!-- <div>
          <input v-model="search" type="text" placeholder="search booking id, vehicle id, name, agent etc" class="form-control label">
      </div> -->
      <div>
        <b-card v-if="agents.length > 0">
          <span
            v-for="(data, index) in agents"
            :key="index"
            @click="viewAgent(data)"
            ><b-avatar
              v-b-tooltip.html
              :title="
                `<strong>${data.userName}</strong> <br> Last Seen ${momentf(
                  data.updatedAt
                )}`
              "
              class="mr-2 mb-2"
              badge
              :badge-variant="data.isOnline == true ? 'success' : 'danger'"
              :src="data.displayPicture"
            ></b-avatar
          ></span>
          <p class="labels m-0 p-0" style="font-size:10px;color:gray">
           <i class="fal fa-lightbulb-on"></i> Click on avatar to view agent details.
          </p>
          <div
            class="m-0 p-0"
            v-for="(datax, index) in agents"
            :key="'abc' + index"
          >
              <b-alert variant="primary" class="m-0 p-0 p-2 my-3 border-0" body-class="m-0 p-0" show v-if="isToday(datax.dob) && datax.id != agentId">
                <div class="d-flex justify-content-between">
                  <div class="my-auto">
                    <p class="m-0 p-0 labels">
                      {{datax.dob | moment('ll')}}
                    </p>
                    <h5 class="m-0 p-0">
                    <strong>
                        <i class="fal fa-birthday-cake mr-2"></i>
                        {{datax.name}} has birthday today. Wish him luck!
                      </strong>
                    </h5>
                  </div>
                  <div class="my-auto">
                    <b-button class="px-2" :disabled="!datax.email" :href="'mailto:' + datax.email" variant="primary">
                    <i class="fal fa-paper-plane"></i>
                    Wish {{ datax.name }}</b-button>
                  </div>
                </div>
              </b-alert>
              <b-alert show variant="primary" class="my-3" v-else-if="isToday(datax.dob) && datax.id == agentId">
                  <h5 class="m-0 p-0">
                    <strong>
                      <i class="fal fa-birthday-cake mr-2"></i>
                      HAPPY BIRTHDAY 
                      <span class="text-uppercase">
                        {{datax.name}}
                      </span>
                    </strong>
                  </h5>
                <p class="labels m-0 p-0">
                  “ Wishing you the best on your birthday and everything good in the year ahead. ”
                </p>
              </b-alert>
              <b-alert  variant="primary" class="m-0 p-0 p-2 my-3 border-0" body-class="m-0 p-0" show v-if="isToday(datax.doj) && datax.id != agentId">
                <div class="d-flex justify-content-between">
                  <div class="my-auto">
                    <p class="m-0 p-0 labels">
                      {{datax.doj | moment('ll')}}
                    </p>
                    <h5 class="labels m-0 p-0 my-auto">
                      <strong>
                        <i class="fal fa-handshake"></i>
                        Congratulate {{datax.name}} on their {{dateDiff(datax.doj)}} work anniversary.
                      </strong>
                    </h5>
                  </div>
                  <div class="my-auto">
                    <b-button class="px-2" :disabled="!datax.email" :href="'mailto:' + datax.email" variant="primary">
                    <i class="fal fa-paper-plane"></i>
                    Congratulate {{ datax.name }}</b-button>
                  </div>
                </div>
              </b-alert>
              <b-alert show variant="primary" class="my-3" v-else-if="isToday(datax.doj) && datax.id == agentId">
                <h5 class="m-0 p-0">
                  <strong>
                    <i class="fal fa-handshake"></i>
                  Congratulations {{datax.name}} on your {{dateDiff(datax.doj)}} work anniversary.
                  </strong>
                  </h5>
                <p class="labels m-0 p-0">
                  “ Hard work, Loyalty, and Diligence are the cornerstones of great employees. Congratulations on your work anniversary with us! ”
                </p>
              </b-alert>
          </div>
        </b-card>
      </div>
      <b-row class="my-4 p-0">
        <b-col md="8">
          <div class="my-2" v-for="(data, index) in feeds" :key="index">
            <div class="">
              <b-badge variant="primary">{{ data.type }}</b-badge>
              <div v-if="data.type == 'Booking ended'">
                <p class="m-0 p-0 mt-2 text-weight-bold">
                  {{ data.name }} ended the booking {{ data.bookingId }}
                </p>
              </div>
              <div v-else>
                <p class="m-0 p-0 mt-2 text-weight-bold">
                  {{ data.description }}
                </p>
              </div>
              <p class="text-muted m-0 p-0">
                {{ data.createdAt | moment("lll") }}
                <span
                  v-if="
                    data.type == 'first assigned' ||
                      data.type == 'Booking ended'
                  "
                  class="btn-link"
                  @click="viewBooking(data.bookingId)"
                >
                  , {{ data.bookingId }}
                </span>
                <span
                  v-if="data.type == 'Vehicle Status Change'"
                  class="btn-link"
                  @click="viewVehicle()"
                >
                  , {{ data.bookingId }}
                </span>
              </p>
              <p class="text-muted">Created by {{ data.name }}</p>
            </div>
            <hr />
          </div>
          <div class="text-center" v-if="feeds.length < totalFeeds">
            <b-button variant="outline-primary" @click="getNextfeeds"
              >Load More</b-button
            >
          </div>
          <div v-if="loading" class="text-center my-4">
            <b-spinner></b-spinner>
          </div>
        </b-col>
        <b-col md="4" class="m-0 p-0">
          <b-card class="sticky-top mt-5 border-0">
            <p style="font-size:15px">Leaderboard</p>
            <leaderboard></leaderboard>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { HTTP2 } from ".././axios/http-common";
import leaderboard from "../components/homepage/views/leaderBoard.vue";
import uaview from "../components/reusuable/userAgentQuickView.vue";
import moment from "moment";
import * as _ from "lodash";
export default {
  data() {
    return {
      loading: false,
      feeds: [],
      totalFeeds: 0,
      offset: 0,
      limit: 10,
      agents: [],
      trial: false,
      selectedAgent: null,
    };
  },
  beforeMount() {
    this.loadData();
  },
  components: {
    leaderboard,
    uaview,
  },
  computed: {
    agentId() {
      return localStorage.getItem("agent_id");
    },
  },
  methods: {
    dateDiff(d){
      var startDate = moment();
      var endDate = moment(d);
      var yearDiff = startDate.diff(endDate, 'years');
      return yearDiff + (yearDiff > 1 ? ' years' : 'year')
    },
    isToday(d) {
      const date = new Date(d);
      const today = new Date();
      const dateMonthCheck =
        today.getMonth() == date.getMonth() &&
        today.getDate() == date.getDate();
      return dateMonthCheck;
    },
    viewAgent(data) {
      this.trial = true;
      this.selectedAgent = data;
    },
    momentf(date) {
      return moment(date).format("lll");
    },
    viewBooking(id) {
      window.location.href =
        "https://ontrack-operations.web.app/viewBooking/" + id;
    },
    viewVehicle() {
      window.location.href = "https://ontrack-operations.web.app/vehicles/";
    },
    async loadData() {
      this.loading = true;
      try {
        const { data } = await HTTP2.get("/agentActivity");
        const agent = await HTTP2.get("/get/agent");
        const sorted = _.orderBy(agent.data, "updatedAt", "desc");
        const status = _.orderBy(sorted, "isOnline", "desc");
        this.agents = status;
        this.feeds = data.data;
        this.totalFeeds = data.total;
      } finally {
        this.loading = false;
      }
    },
    async getNextfeeds() {
      try {
        this.loading = true;
        this.offset = this.offset + this.limit;
        const { data } = await HTTP2.get(
          "/agentActivity?offset=" + this.offset
        );
        data.data.forEach((x) => {
          this.feeds.push(x);
        });
        this.totalFeeds = data.total;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
.feeds {
  font-size: 13px;
}
</style>
